
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class RoadServiceInfo extends Vue {
    goToHomePage() {
        this.$emit('goToHomePage', { vendorLocationUrl: `https://${this.$t('label.vikingRoadServiceUrl')}/` });
    }
}
